var React = require('react');

function Top (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"22","cy":"22","r":"20.5","transform":"rotate(90 22 22)","stroke":"black","strokeWidth":"3","key":0}),React.createElement("path",{"d":"M20.5484 34L20.5484 15.4811L14 22.0649L12 20.0865L22.0323 10L32 20.0865L30 22.0649L23.4516 15.4486L23.4516 34L20.5484 34Z","fill":"black","key":1})]);
}

Top.defaultProps = {"width":"44","height":"44","viewBox":"0 0 44 44","fill":"none"};

module.exports = Top;

Top.default = Top;
